import styled from 'styled-components'

export const Container = styled.div`
    position: relative;
    border-radius: 0px 8px 8px 0px;
    border-left: ${({ theme }) => `3px solid ${theme.colors.blue}`};
    background-color: ${({ theme }) => theme.colors.white};
    padding: .5rem;
    width: 700px;
    max-height: 100px;
`

export const Row = styled.div`
    display: flex;
    align-items: center;
    gap: .2rem;
`

export const Action = styled.span<{backgroundColor: string}>`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    background-color: ${({ backgroundColor }) => backgroundColor};
    width: auto;
    height: 24px;
    border-radius: 56px;
    color: #FFF;
    padding: 10px;
    margin: .5rem .5rem 0 0;
`
